import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // signal to the host page that Angular loaded successfully
    (window as any).angularAppLoaded = true;
  })
  .catch((err) => {
    console.error('Angular bootstrap failed:', err);

    const payload = {
      message: err instanceof Error ? err.message : String(err),
      stack: err instanceof Error ? err.stack : undefined,
      url: location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      context: 'angular-bootstrap-failure'
    };

    // Determine the logging endpoint
    const baseUrl = environment.endpoints.baseUrl ?? ''; // if empty, use relative URL
    const logEndpoint = `${baseUrl}/Home/LogClientError`;

    // Fire-and-forget error log
    fetch(logEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => {
      // Don't throw on error
    });
  });

if (isDevMode()) {
  console.log('Development Mode is set in environment.ts');
}
